import { Link } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import Callout from '#app/components/common/callout'
import PlentyBody from '#app/components/typography/plenty-body'
import PlentyHeading from '#app/components/typography/plenty-heading'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

import { useCartStore } from '#app/store/cart'
import { type PlentyLineItem } from '#types/cart'
import ProductBagCard from './product-bag-card'
import { getTotalItemsFromCart, type BagItemProps } from '.'

interface ProductBagCardProps {
	productItemData: BagItemProps | null
	nudgeMessage?: string | null
}

const BagItemContent = ({
	nudgeMessage,
	productItemData,
}: ProductBagCardProps) => {
	let { t } = useTranslation('shopping_bag')
	const { cart } = useCartStore()

	return (
		<div className="flex flex-col gap-y-3">
			<div className="flex flex-row justify-between">
				<div className="flex flex-row items-start gap-x-2">
					<Icon name="check" size="lg" className="text-mint-green-60" />
					<PlentyHeading as="h7">
						{t('added_to_your_shopping_bag')}
					</PlentyHeading>
				</div>
			</div>
			<div className="flex flex-col gap-2">
				{nudgeMessage && (
					<PlentyBody>
						{t('product_details_page:nudge_message_store_info', {
							store:
								productItemData?.newDistributionChannel?.name?.en || 'store',
						})}
					</PlentyBody>
				)}
				{productItemData?.newItems &&
					productItemData?.newItems.map(item => {
						if (!item) return null
						return (
							<ProductBagCard
								key={item.id}
								plentyLineItem={item as PlentyLineItem}
							/>
						)
					})}
			</div>
			<div className="flex flex-col gap-2 lg:flex-row lg:space-x-2">
				<Link to={'/shopping-bag'}>
					<Button
						variant="secondary"
						size="secondary"
						fullWidth
						data-testid="pdp-go-to-shopping-bag-button"
					>
						{t('go_to_shopping_bag')}{' '}
						{`(${getTotalItemsFromCart(cart?.lineItems || [])})`}
					</Button>
				</Link>
				<Link to={'/checkout'} className="flex flex-grow ">
					<Button
						fullWidth
						size="secondary"
						data-testid="pdp-go-to-checkout-button"
					>
						{t('checkout:checkout_header')}
					</Button>
				</Link>
			</div>
			{nudgeMessage && (
				<Callout color="secondary">
					<PlentyBody size="md">{nudgeMessage}</PlentyBody>
				</Callout>
			)}
		</div>
	)
}

export default BagItemContent
